import {
  SET_JOURNAL_TABLE_FILTER,
  UNSET_JOURNAL_TABLE_FILTER,
} from './types';
import initialState from './initialState';

function journalTableReducer(state = initialState, action) {
  switch (action.type) {
    case SET_JOURNAL_TABLE_FILTER:
      return {
        ...state,
        journalTableFilter: action.filter,
      };
    case UNSET_JOURNAL_TABLE_FILTER:
      return {
        ...state,
        journalTableFilter: '',
      };
    default:
      return state;
  }
}

export default journalTableReducer;
